<template>
  <n-config-provider :theme-overrides="THEME_OVERRIDES">
    <router-view
      :key="$route.name"
      class="min-h-screen"
    />
  </n-config-provider>
</template>

<script>
import { THEME_OVERRIDES } from '@/fixtures/ThemeColor'
export default {
  name: 'App',
  data() {
    return {
      THEME_OVERRIDES
    }
  }
}
</script>
